import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { Order } from "../../../../../objects/orders/order";
import { OrderItem } from "../../../../../objects/orders/orderItem";
import { CalculatorHelper } from "../../../../../common/helpers/calculatorHelper";
import { OrderItemOptions } from "../../../../../objects/orders/orderItemOptions";
import { CalculatorType } from "../../../../../objects/orders/calculatorType";
import { PdaType } from "../../../../../objects/orders/PdaType";
import { Product } from "../../../../../objects/products/product";
import { CanadianCurrencyCode } from "../../../../../objects/currencyExchange/canadianCurrencyCode";
import { OrderService } from "../../../../../services/orderService";
import { AccordionPanelComponent } from "ngx-bootstrap";
import { EmailRequest } from "../../../../../objects/email/EmailRequest";
import { EmailTemplateType } from "../../../../../objects/email/emailTemplateType";
import { EmailService } from "../../../../../services/emailService";
import { TabDirective, WizardComponent } from "ngx-wizard";
import { TariffSource } from "../../../../../objects/tariffs/tariffSource";
import * as ps from "perfect-scrollbar";
import { NgForm } from "@angular/forms";
import { ToastsManager } from "ng2-toastr";
import { GoogleTagService } from "../../../../../services/google-tag.service";
import { TaxService } from "../../../../../services/calculator/tax.service";
import { OrderOptions } from "../../../../../objects/orders/orderOptions";
import { ViewType } from "../../../../../objects/users/viewType";
import { ScreenHelper } from "../../../../../common/helpers/screenHelper";
import { Router } from "@angular/router";
import { PageVisit } from "../../../../../objects/pages/pageVisit";
import { ConfigService } from "../../../../../services/configService";

@Component({
    selector: "result-tab-v2",
    templateUrl: "./result-tab-v2.component.html",
    moduleId: module.id.toString()
})
export class ResultTabV2Component implements OnInit, AfterViewInit {

    @Input()
    public order: Order;
    @Input()
    public defaultProducts: Product[] = [];
    @Input()
    public canadianCurrencyCodes: CanadianCurrencyCode[] = [];
    @Input()
    public productName: string;
    @Input()
    public orderItem: OrderItem;
    @Input()
    public wizard: WizardComponent;
    @Input()
    public isNeedSendEmail: boolean;
    @Input()
    public marketingURL: string = null;
    @Output()
    public getAnotherQuote: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    public isThanksTabShow: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    public isQuestionOrCallTabShow: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    public showEmailText: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    public createdOrder:  EventEmitter<Order> = new EventEmitter<Order>();
    @Input() mainElement: ElementRef;

    @ViewChild('accordionRef')
    public accordionRef: ElementRef;

    @ViewChild('accordionRef')
    public tab: TabDirective;

    @ViewChild('emailForm')
    public emailFormRef: NgForm;

    @ViewChild('group')
    private accordion: AccordionPanelComponent;

    public currentEmail: string;

    @Input()
    public focusInput: any;
    @Output()
    public onTabSelected: EventEmitter<PageVisit> = new EventEmitter<PageVisit>();

    public get isVehicle(): boolean {
        return CalculatorHelper.isVehicle(this.order);
    }

    public get currency(): string {
        if (!this.order || !this.order.Currency)
            return 'CAD';

        return this.order.Currency.Name;
    }

    public get isCanadianCalculator(): boolean {
        return CalculatorHelper.getCalculatorType(this.order.Locations) == CalculatorType.CanadianImport;
    }


    private initialized: boolean = false;
    public calculatorHelper = CalculatorHelper;
    public isEmailSending: boolean = false;
    public isProcessing: boolean = false;
    public viewTypeEnum: ViewType;
    public viewType: string;
    public isSendQuoteEmail: boolean = false;


    constructor(public orderService: OrderService,
                public emailService: EmailService,
                public toastrService: ToastsManager,
                public googleTagService: GoogleTagService,
                public taxService: TaxService,
                public router: Router,
                private config: ConfigService) {
    }

    public ngOnInit(): void {
        this.initialized = true;

        this.viewTypeEnum = ScreenHelper.getViewType();
        this.viewType = ViewType[this.viewTypeEnum];
    }

    public ngAfterViewInit(): void {
        this.scrollBottom();
    }

    public calculateOrder(): void {
        this.isProcessing = true;

        this.order.CalculatorType = CalculatorHelper.getCalculatorType(this.order.Locations);

        if (this.order.CalculatorType == CalculatorType.UsaImport) {
            this.order.Currency = this.canadianCurrencyCodes.find(x => x.Name == 'USD');
        } else {
            this.order.Currency = this.canadianCurrencyCodes.find(x => x.Name == 'CAD');
        }

        let lastHsNumber = this.isVehicle ? '99' : '98';
        let source = this.isCanadianCalculator ? TariffSource.Canada : TariffSource.Usa;

        this.orderItem.Product = this.defaultProducts.find(x => x.Source == source && x.HsCode == `9999.99.99.${lastHsNumber}`);

        if(this.isVehicle && this.order.OrderItems.length > 0){
            this.productName = null;
        }

        if (this.router.url.startsWith('/calculator2/public')) {
            this.order.Source = "Public Calculator";
        }

        this.orderItem.Product.Name = this.productName ? this.productName : this.orderItem.Product.Description;

        if (this.isVehicle) {
            if (this.isCanadianCalculator) {
                this.orderItem.Flags |= OrderItemOptions.IsPassVehicle; // Always yes as in requirements
                this.orderItem.Flags |= OrderItemOptions.IsVehicleParts; //RIV => use lesser amount as in requirements
            } else { //For Usa Vehicle Calculator
                this.orderItem.Type |= PdaType.DOT;
                this.orderItem.Type |= PdaType.EPA;
            }//Set static 40$ only for vehicle

        }

        CalculatorHelper.getTariffs(this.orderItem.Product.Source, CalculatorHelper.getTariff(this.orderItem, this.order, false , this.taxService.canadianHsCodesAlAndSteel10, this.taxService.canadianHsCodesAlAndSteel25, this.taxService.canadianHsCodesChina0, this.taxService.usaHsCodesChina25), this.orderItem);

        this.order.OrderItems = [this.orderItem];

        if (this.order.IsCommercial == null)
            this.order.IsCommercial = false;

        if (this.order.Flag && !this.order.Flag.hasFlag(OrderOptions.IsPulic))
            this.order.Flag |= OrderOptions.IsPulic;

        if(!this.order.Flag)
            this.order.Flag = OrderOptions.IsPulic;


        this.orderService.publicCreate(this.order, this.marketingURL, this.viewType).then(response => {
            this.isProcessing = false;

            if (!response || !response.Data)
                throw new Error("Order was not created");

            this.order = response.Data;
            this.orderItem = this.order.OrderItems[0];

            this.order.CalculatorType = CalculatorHelper.getCalculatorType(this.order.Locations);
            this.scrollPanel();



            if (this.order.Customer.Email && this.isNeedSendEmail) {
                let emailRequest = (new EmailRequest({ OrderId: this.order.Id, EmailType: EmailTemplateType.OrderToCustomer, Comment: "" }));

                this.emailService.sendOrderToCustomer(emailRequest);
                this.toastrService.success("Sending mail succeeded");
            }

        }).catch(_ => this.isProcessing = false);
    }

    public getClass(): any {
        if (!this.initialized || !this.accordion)
            return "panel-default";
        if (this.accordion.isOpen)
            return "accordion-open";
        else
            return "";
    }

    public sendEmail(event: any, action: 'goToGetAnotherQuote' | 'goToThanksTab' | 'goToGetStarted' | 'sendEmailToCustomer') {
        if (event != null)
            event.preventDefault();


        switch (action) {
            case ('goToGetAnotherQuote'): {
                this.getAnotherQuote.emit(true);
                break;
            }
            case ('goToThanksTab'): {
                //Continue Clicked then show last tab with email
                this.isQuestionOrCallTabShow.emit(false);
                this.isThanksTabShow.emit(true);
                this.moveToNextTab(false);
                break;
            }
            case ('goToGetStarted'): {
                this.goToGetStarted();
                break;
            }
            case ('sendEmailToCustomer'): {
                this.sendEmailToCustomer();
                break;
            }
        }
        this.createdOrder.emit(this.order);
        this.googleTagService.clearEventsArray();
    }

    private sendEmailToCustomer(): void {
        if (this.currentEmail) {
            this.order.Customer.Email = this.currentEmail;
            this.isEmailSending = true;

            let emailRequest = (new EmailRequest({ OrderId: this.order.Id, EmailType: EmailTemplateType.OrderToCustomer, Comment: "" }));

            this.orderService.create(this.order, this.viewType).then(x => {
                this.emailService.sendOrderToCustomer(emailRequest);
            });

            this.toastrService.success("Sending mail succeeded");

            this.googleTagService.pushData('quota', {'event' : 'formSubmitted', 'formName' : 'Completed Quote Page - Email'})

            this.isEmailSending = false;
            this.isSendQuoteEmail = true;
            this.showEmailText.emit(true);
        }
    }

    public goToGetStarted() {
        this.isQuestionOrCallTabShow.emit(true);
        this.isThanksTabShow.emit(false);
        this.moveToNextTab(false);

        //  // TEMP REMOVE FOR TEST BY TASK https://jira.ak-tech.org/browse/BB-2852
        // if (this.config.config.SelfServeAppUrl) {
        //     window.location.href = this.config.config.SelfServeAppUrl;
        // }
    }

    public moveBack(){
        this.order.Id = null;
        this.orderItem.Id = null;
        this.createdOrder.emit(this.order);
        setTimeout(_ => this.wizard.previousTab(true), 0);
    }

    public moveToNextTab(move: boolean) {
        setTimeout(_ => this.wizard.nextTab(move), 0);
    }

    public scrollPanel(): void {
        setTimeout(() => {
            this.scrollBottom();
            this.addScroll()
        }, 150);
    }

    public scrollBottom(): void {
        let el = this.mainElement.nativeElement.querySelector('.panel-body');
        if (el)
            try {
                el.scrollTop = el.scrollHeight;
            } catch (err) {
            }
    }

    public addScroll(): void {
        let el = this.accordionRef.nativeElement.querySelector('.panel-body');
        ps.initialize(el);
    }



}



// WEBPACK FOOTER //
// ./app/components/calculator/public/mobile/result-tab/result-tab-v2.component.ts